<template>
  <div>
    <BreadCrumb :data="breadCrumb" />
    <b-card no-body>
      <div class="support-details-main">
            <div class="support-details">
              <div class="support-head">
                <h2 class="support-head-text">{{faultSupport.product && faultSupport.product.name}}</h2>
                <h4 class="support-head-text"> #{{faultSupport.fault_support_no}}</h4>
              </div>  
              <div class="info-1">
                  <div> <strong> Müşteri: </strong> {{faultSupport.customer.name}} </div>
                  <div> <strong> Ürün Seri No: </strong> {{faultSupport.product_serial_number}} </div>
                  <div v-if="pieces"> <strong> Yan Ürünler: </strong> {{pieces}} </div>
                </div>
              <hr>
              <div  class="description">
                <p v-if="faultSupport.problem"> <strong> Problem: </strong> {{faultSupport.problem}} </p>
                <p v-if="faultSupport.description" >  <strong> Açıklama: </strong>  {{faultSupport.description}} </p>
                <div class="faultDetail">
                  <div class='steps' id='steps'>
                    <div class="step" v-for="mv in movements" :key="mv.id">
                      <div :class="'number completed '+mv.status.variant"> <b-icon :icon="mv.status.icon" /> </div>
                      <div class='info'>
                        <p class='title'> {{ mv.status.name }} </p>
                        <p class='text'> {{ mv.description }}</p>
                        <p class='text'> <strong> {{ mv.user.firstname +' '+mv.user.lastname +'('+mv.user.username+')'}} </strong></p>
                        <p class='text'> {{ dateFormat(mv.created_at)}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="carousel-container">
                    <b-carousel id="images-carousel" v-model="image" controls no-animation indicators>
                      <b-carousel-slide
                        v-for="image in images"
                        :key="images.indexOf(image)"
                        :img-src="server + image.name">
                      </b-carousel-slide>
                    </b-carousel>
                  </div>
                </div>
              </div>
              <hr>
              <div class="info-1">
                <div> <strong> Oluşturma Tarihi: </strong> {{dateFormat(faultSupport.created_at)}} </div>
                <div> <strong> Son Güncelleme: </strong> {{dateFormat(faultSupport.updated_at)}} </div>
              </div>
            </div>
          </div>
      <template #footer>
        <div class="supportStatus"> 
          <span v-if="faultSupport.status == 'open'">
            <b-alert variant="danger" show>
              <b-icon icon="exclamation-triangle-fill" animation="throb" font-scale="1.5" ></b-icon>
              <span > AÇIK </span>
            </b-alert>
          </span>
          <span v-else>
            <b-alert variant="success" show>
              <b-icon icon="check" animation="throb" font-scale="1.5" ></b-icon>
              <span > {{faultSupport.fault_support_result.name}} </span>
            </b-alert>
          </span>
          <div class="action-buttons"  v-if="faultSupport.status == 'open'">
            <b-button variant="primary" @click="modal('image')">Resim Ekle</b-button>
            <b-button variant="warning" @click="modal('movement')">Yeni Arıza Hareketi Ekle</b-button>
            <b-button variant="success" @click="modal('close')">Sonlandır</b-button>
          </div>
        </div>
      </template>
    </b-card>

    <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm"
      :modalName="modalName"
    />
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb"
import Table from "@/components/Table"
import Modals from "./modals/"
import moment from 'moment'

const breadCrumb = [
  { label: "Stoklar", url: "/Stock/List" },
  { label: "Arıza Destekleri", url: "/Stock/FaultSupports" },
  { label: "Detaylar", url: "/Stock/FaultSupports/Add" }
]

let fields = [
  { key: "status", label: "Durum", type:"badge", keys: ["status", "name"] },
  { key: "description", label: "Açıklama", keys: ["description"] },
  { key: "user", label: "Atanan Kişi", keys: ["user", "username"] },
  { key: "created_at", type:"date", label: "Oluşturma Tarihi", keys: ["created_at"] },
];

let filtered = ["status", "user", "created_at", "description"];

export default {
  name: 'FaultSupportDetails',
  components: {
    BreadCrumb, Table, Modals
  },
  data() {
    return {
      breadCrumb, fields, filtered,
      modalProps: {}, modalName: "", modalOpen: false,
      image: 0,
      downloadLinks: [],
      server: process.env.VUE_APP_API_SERVER,
      currentForm: "faultSupports"
    }
  },
  computed: {
    itemId() {
      return this.$route.params.id
    },
    isLoading() {
      return this.$store.getters.getStockLoading
    },
    faultSupport() {
      return this.$store.getters.faultSupport
    },
    images() {
      return this.$store.getters.faultSupportImages ? this.$store.getters.faultSupportImages : []
    },
    pieces() {
      return this.$store.getters.faultSupportPieces ? this.$store.getters.faultSupportPieces
      .map(test => test.name).join(', ') : ''
    },
    movements() {
      return this.faultSupport.movements
    },
  },
  watch: {
    images() {
      this.downloadLinks = []
      this.setDownloadLinks()
    }
  },
  methods: {
    dateFormat(val){
      return moment(String(val)).format('DD MMMM YYYY') 
    },
    openModal(state, modal, props){
      this.modalOpen = state
      if(state){
        this.modalName = modal
        this.modalProps = props
      }
    },
    modal(key) {
      this.faultSupport.isDetailPage = true
      this.openModal(true, key, { ...this.faultSupport, type: key });
    },
    async fetchFaultSupport() {
      await this.$store.dispatch('fetchFaultSupport', this.itemId)
      await this.$store.dispatch('fetchFaultSupportImages', this.itemId)
      await this.$store.dispatch('fetchFaultSupportPieces', this.itemId)
    },
    async setDownloadLinks() {
      if (!this.images.length) return
      this.images.forEach(async i => {
        const file = await this.$store.dispatch('getStockFileUrl', i.name)
        this.downloadLinks.push(file)
      })
    }
  },
  async created() {
    await this.fetchFaultSupport()
  }
}
</script>

<style scoped>
  @import "./styles/faultSupportDetail.min.css";
</style>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/FaultSupportsDetail.vue